<template>
  <div class="axj-course">
    <course-header
      @create="handleCreate"
    />
    <course-main
          :data="tableData"
          @update="handleUpdate"
          @uploadSuccess="handleUploadSuccess"
          @delete="handleDeleteCourse"
          @previewHomeWork="handlePreviewHomeWork"
    />
    <course-footer
      :page-data="page"
      @page-change="handlePaginationChange"
    />
    <course-edit
      :course-id="courseEdit.courseId"
      :show.sync="courseEdit.show"
      :is-create="courseEdit.create"
    />
    <home-work
      @updateSuccess="handlePreviewHomeWork"
      @close="handleHomeWorkClose"
      :show-home-work.sync="homeWork.show"
      :data="homeWork.data"
      :active-num="homeWork.ActiveNum"
      :id="homeWork.id"
      :row="homeWork.row"
    />
    <!--    <within-school-header-->
    <!--      @create="handleCreate"-->
    <!--    />-->
    <!--    <within-school-main-->
    <!--      :data="tableData"-->
    <!--      @update="handleUpdate"-->
    <!--    />-->
    <!--    <within-school-footer-->
    <!--      :page-data="page"-->
    <!--      @page-change="handlePaginationChange"-->
    <!--    />-->
  </div>
</template>

<script>

import CourseHeader from "./component/course-header/index";
import CourseMain from "./component/course-main/index";
import CourseFooter from "./component/course-footer/index";
import {listCourse,deleteCourse,listHomeWork,getHomeSubmits} from '@/api/axj-help/axj-help-course.js'
import CourseEdit from "./action/courseEdit";
import HomeWork from "./component/home-work/index";
export default {
  name: "axj-course",
  components: {HomeWork, CourseEdit, CourseFooter, CourseMain, CourseHeader},
  created() {
    this.initData()
    let that=this
    window.handleNext=function (){
      if(that.page.page*that.page.limit<that.page.pageTotal){
        that.page.page=that.page.page+1
        that.handlePaginationChange(that.page)
      }
    }
    window.handlePre=function (){
      if(that.page.page>1){
        that.page.page=that.page.page-1
        that.handlePaginationChange(that.page)
      }
    }
  },
  data(){
    return {
      homeWork:{
        show:false,
        data:[],
        ActiveNum:0,
        id:0,
        row:undefined
      },
      tableData:[],
      page: {
        page: 1,
        limit: 5,
        desc: true,
        preload: true,
        pageTotal: 0
      },

      courseEdit:{
        show:false,
        create:true,
        courseId:undefined,

      }
    }
  },
  methods:{
    handleHomeWorkClose(){
      this.homeWork.show=false
    },
    async handlePreviewHomeWork(row){
      let res= await listHomeWork({
        where:JSON.stringify({
          course_id:row.id
        }),
        preload: true
      })
      this.homeWork.ActiveNum=row.select_sum
      this.homeWork.data=[]
      await new Promise((resolve,reject)=>{
        let array= res.data.lists
        if(array.length==0){
          resolve('success')
        }
        for(let x=0;x<array.length;x++){
          getHomeSubmits({
            where:JSON.stringify({
            homework_id:array[x].id
            })
          }).then(rres=>{
            array[x].completed=rres.data.lists.length
            this.homeWork.data.push(array[x])
          })
          if(x===array.length-1){
            resolve('success')
          }
        }
      })
      this.homeWork.id=row.id
      this.homeWork.row=row
      this.homeWork.show=true
    },
    handleDeleteCourse(id){
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.deleteCourse(id)
        this.initData()
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteCourse(id){
      return new Promise((resolve, reject)=>{
        deleteCourse(id).then(res=>{
          resolve()
        },error => {
        })
      })
    },
    handleUploadSuccess(){
      this.initData()
    },
    handlePaginationChange (val) {
      this.page = val
      this.initData()
    },
    handleClubClose(){
      this.withInEdit.show=false
    },
    handleCreate(){
      console.log('xxx')
      this.courseEdit.create=true
      this.courseEdit.show=true
    },
    initData(){
      let user=this.$store.getters.getUser
      listCourse({
        ...this.page,
        where:JSON.stringify({
          user_id:user.uid
        }),
        preload:true
      }).then(res=>{
        this.tableData=res.data.lists
        this.page.pageTotal=res.data.total
        // commonModels.logs('info','withinSchool','show-club-list-success!',0)
      },error=>{

      })
    },
    handleUpdate(id){
      this.courseEdit.courseId=id
      this.courseEdit.create=false
      this.courseEdit.show=true
    },
    handleUpdated(){
      this.withInEdit.show=false
      this.initData()
    },
    handleCreated(){
      this.withInEdit.show=false
      this.initData()
    }
  }
}
</script>

<style slot-scope lang="scss">
.axj-course{
  .el-table__body{
    tr:hover{
      .axj-show-club-main-announce-list{
        .el-collapse-item__header{
          background-color: #F2F5F8;
        }
        .el-collapse-item__content{
          background-color: #F2F5F8;
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-help/axj-course/index.vue